import { render, staticRenderFns } from "./createowner_modal.vue?vue&type=template&id=10bed7a3&scoped=true&"
import script from "./createowner_modal.vue?vue&type=script&lang=js&"
export * from "./createowner_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bed7a3",
  null
  
)

export default component.exports